// Librairies
import React from 'react';
// import { withTranslation } from 'react-i18next';
import ModuleEncart from './ModuleEncart';

export class ModuleEncartList extends React.Component {
	render() {
		const { t, data } = this.props;

		const childElements = data.map(element => {
			return <ModuleEncart key={element.imgSrc} element={element} />;
		});

		return (
			<React.Fragment>
				{/* Les images doivent être en 460x305 */}
				<div className="row">{childElements}</div>
			</React.Fragment>
		);
	}
}

